// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-790471bc]{border-width:1px}.icon[data-v-790471bc]{position:absolute;right:12px;top:40%}.icon-md[data-v-790471bc]{font-size:21px;font-weight:300;transform:scaleX(1.2)}.has-error[data-v-790471bc]{--tw-border-opacity:1;border-color:rgba(217,0,26,var(--tw-border-opacity))}", ""]);
// Exports
module.exports = exports;
